
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFailedDeliveryCost"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeframe"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateRange"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"failedDeliveryCost"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"timeframe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeframe"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monthly"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"month"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryFee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"volume"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reasonCosts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reason"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"reasonCostsGroupByMonth"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"month"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"reasons"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reason"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"failedDeliveryCostTopHubs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"timeframe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeframe"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryCost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packagePrice"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"failedDeliveryCostTopAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"timeframe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeframe"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryCost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packagePrice"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"failedDeliveryCostTopProvinces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"timeframe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeframe"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"provinceId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryCost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packagePrice"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"failedDeliveryCostTopReasons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"timeframe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeframe"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"failureReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packageName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryCost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packagePrice"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":952}};
    doc.loc.source = {"body":"query getFailedDeliveryCost(\n  $timeframe: DateRange\n) {\n  failedDeliveryCost(\n    timeframe: $timeframe\n  ) {\n    monthly {\n      month\n      amount\n    }\n    deliveryFee\n    price\n    weight\n    volume\n    reasonCosts {\n      amount\n      reason\n    }\n    reasonCostsGroupByMonth {\n      amount\n      reason\n      month\n    }\n    reasons {\n      count\n      cost\n      reason\n    }\n  }\n\n  failedDeliveryCostTopHubs(\n    direction: DESC\n    timeframe: $timeframe\n  ) {\n    name\n    deliveryCost\n    packagePrice\n  }\n\n  failedDeliveryCostTopAreas(\n    direction: DESC\n    timeframe: $timeframe\n  ) {\n    name\n    deliveryCost\n    packagePrice\n  }\n  failedDeliveryCostTopProvinces(\n    direction: DESC\n    timeframe: $timeframe\n  ) {\n    name\n    provinceId\n    deliveryCost\n    packagePrice\n  }\n  failedDeliveryCostTopReasons(\n    direction: DESC\n    timeframe: $timeframe\n  ) {\n    failureReason\n    packageName\n    deliveryCost\n    packagePrice\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getFailedDeliveryCost"] = oneQuery(doc, "getFailedDeliveryCost");
        
